import React from 'react';
import { Wrapper, CustomReactTable } from '../Table/styled';
import { getColumns } from './columns';
import useTheme from 'Hooks/UseTheme';
import { useDispatch, useSelector } from 'react-redux';
import { multipleAgentExecutionSetSelected, setOrderByAgentsExecutions } from 'store/Agents/actions';
import { selectAgentExecutions, selectAgentExecutionSelected } from 'store/Agents/selectors';
import { get } from 'lodash';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';

const RunStatusLog = ({ agents }) => {
  const dispatch = useDispatch();
  const { themeStyles } = useTheme();
  const show = useSelector((state) => selectModal(state, MODAL_AGENT_EXECUTOR_DETAIL));
  const columns = getColumns(themeStyles, show);
  const agentsExecutions = useSelector(selectAgentExecutions);
  const agentsExecutionsSelected = useSelector(selectAgentExecutionSelected);

  const fetchData = (tableState) => dispatch(setOrderByAgentsExecutions(tableState.sorted));

  const getTrProps = (rowInfo) => {
    const rowId = get(rowInfo, 'original.id', '');
    const isSelected = agentsExecutionsSelected.some((e) => e.id === rowId);
    if (rowInfo && rowInfo.row) {
      return {
        onContextMenu: (e) => {
          e.preventDefault();
          if (!isSelected) {
            // unselectAll();
            dispatch(multipleAgentExecutionSetSelected)(rowInfo.original);
          }
        },
        style: {
          background: isSelected ? `${themeStyles?.backgrounds?.selectedTableItem}` : ''
        }
      };
    }
    return {};
  };

  return (
      <Wrapper>
        <CustomReactTable
          data={ agentsExecutions }
          columns={ columns }
          onFetchData={ fetchData }
          minRows={ 0 }
          manual
          showPagination={ false }
          getTrProps={ (_, rowInfo) => getTrProps(rowInfo) }
        />
      </Wrapper>
  );
};

export default RunStatusLog;
